/**
 * Lazy-laddare för Swiper.
 *
 * Dynamisk import() lägger Swiper i en egen chunk som hämtas först när ett
 * slider-element finns i DOM — används av pc-products, pc-product-cats,
 * pc-post-listing och pc-gallery. Promisen memoiseras så att sliders.js och
 * gallery.js delar samma chunk och samma nedladdning.
 */

let swiperPromise = null

export function loadSwiper() {
    if (!swiperPromise) {
        swiperPromise = Promise.all([import('swiper'), import('swiper/modules')]).then(([core, modules]) => ({
            Swiper: core.default,
            ...modules,
        }))
    }

    return swiperPromise
}
